import { FC, useEffect, useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import InputData from "../Model/InputData";
import { vestResolver } from "@hookform/resolvers/vest";
import { FormSuite } from "../FormModel/FormValidator_Simple_Ecran2";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { SalSimFormProps } from "../FormModel/FormStepProps";
import { tabTypeContrat, tabComParitaire, tabPrefixeOnss, tabSoumisPrecompte, tabEffectifEmployeur } from "../FormModel/FormPlaceholderData";
import { UseCodeListContext } from "../Context/CodeListContext";
import { UseTranslationContext } from "../Context/TranslationContext";
import FormToggleElementDualChoice from "./FormToggleElementDualChoice";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React from "react";
import { Typography } from "@mui/material";
import MUITooltipCustom from "./MUITooltipCustom";
import ResultData, { Cl_Pacible } from "../Model/ResultData";
import MapService from "../services/MapService";
import SalarySimService from "../services/SalarySimService";
import { UseConfigContext } from "../Context/ConfigContext";

const Step2Simple: FC<SalSimFormProps> = (props) => {
  const {codeListForm, getCodeListKey} = UseCodeListContext();
  const { salarySimFormData, updateSalarySimData } = UseSalarySimContext();
  const { currentLanguage, getKeyFromKeyId } = UseTranslationContext();

  const {
    isSimpleSimulationMode,
    salarySimAdvancedFormData,
    UpdateSalarySimMappedData,
    UpdateSalarySimResultData,
  } = UseSalarySimContext();

  const { getServiceUrl } = UseConfigContext();

  const { register, handleSubmit, setValue, formState: { errors, isValid, isValidating }, control } = useForm({
    resolver: vestResolver(FormSuite),
    mode: 'onChange',
    reValidateMode: 'onChange',
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: false,
    shouldUnregister: false,
    delayError: undefined,
  });




  const formNetToBrutCheck = useWatch({ control, name: "NetToBrutCheck", defaultValue: (salarySimFormData.NetToBrut != undefined) ? salarySimFormData.NetToBrut : false });
  const formAmount = useWatch({ control, name: "MonthlyAmount" });

  // We load the validated existing data from the context
  useEffect(() => {

    //init default
    setValue('selectedTypecontrat',1);
    
    if (salarySimFormData != null) {
      setValue('NetToBrutCheck', salarySimFormData.NetToBrut);
      setValue('SelectedContract', salarySimFormData.ContractType);
      setValue('MonthlyAmount', salarySimFormData.MonthlyAmount);
      setValue('GroupInsurance', salarySimFormData.CollectiveInsuranceAmount);
    }
  }, []);

  const formRef = useRef<HTMLFormElement>(null);
  useEffect(() => {
    if (props.requestFormValidation != null && props.requestFormValidation.includes(props.formStep) && formRef.current) {
      formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  },[props.requestFormValidation])


  const SendSalarySimForm = (data: any, GoToNextForm: boolean = true) => {
    //Validation OK
   
    let step2Data: InputData = new InputData();
    step2Data.NetToBrut = data?.NetToBrutCheck;
    step2Data.ContractType = parseInt(data?.selectedTypecontrat);
    step2Data.MonthlyAmount = parseFloat(data?.MonthlyAmount);
    step2Data.CollectiveInsuranceAmount = parseFloat(data?.GroupInsurance);

    if (updateSalarySimData != undefined) {
      updateSalarySimData(step2Data, 2, true);
    }
    
    //props.changeStep(GoToNextForm);
    props.formValidationCallback(props.formStep, true);

  }

  const onFormError = (formErrors : any, e : any) =>{
    props.formValidationCallback(props.formStep, false);
  }

  const ToggleBruttoNetState = (onState : boolean) => {
    setValue("NetToBrutCheck", onState);

    if(formAmount > 0)
    {
      setValue("MonthlyAmount", formAmount, {shouldValidate : true, shouldDirty: true});
    }
  };

  const GetInputFieldCssClass = (inError: boolean) => {
    return ( inError?'text-field w-input inputFieldError inputFixedMaxHeight':'text-field w-input inputFixedMaxHeight' );
  }

  return (

    <>
      <div style={{ display: (props.isCurrentForm ? '' : 'none') }}>
        <form ref={formRef} id="formStep2Simple" onSubmit={handleSubmit((d) => SendSalarySimForm(d), (data, e) => onFormError(data,e))} name="wf-form-Etape2-simplifi" aria-label={getKeyFromKeyId("SECTION_CONTRACT_TYPE")} className="form-step2 formIndex">
          <div id="w-node-a0d8ff03-483e-aca8-b018-4961f53a1948-4b01152b">
            <FormToggleElementDualChoice defaultValueState={formNetToBrutCheck} translationTitle={getKeyFromKeyId("CALCULATION_DIRECTION")} translationValueLeft={getKeyFromKeyId("BRUT")} translationValueRight={getKeyFromKeyId("NET")} valueUpdateCallback={ToggleBruttoNetState} cssClass={"group-toggle"} id={""} />
            {formNetToBrutCheck && <p className="legend input">{getKeyFromKeyId("WARNING_NET_TO_BRUT_SPEED")}</p> }
          </div>
          <div id="group-field-montant" className="group-field">
            <div className="group-label">
              <label aria-hidden="true" htmlFor="cash" className="field-label">{`${getKeyFromKeyId(formNetToBrutCheck?"MONTHLY_AMOUNT_NET":"MONTHLY_AMOUNT_BRUT")} (${getKeyFromKeyId("MANDATORY_FIELD")})`}</label>
            </div>
            <div className="text-field-icon">
              <input type="number" className={GetInputFieldCssClass(errors?.MonthlyAmount?true:false)} maxLength={256} {...register('MonthlyAmount')} placeholder="0 €" id="salary" />
            </div>
            {errors?.MonthlyAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.MonthlyAmount.message as any)}</p>}

          </div>
          <div className="group-field">
            <div className="group-label"><label aria-hidden="true" htmlFor="type-de-contrat" className="field-label">{getKeyFromKeyId("TYPE_CONTRAT")}</label></div>

            <select id="type-de-contrat" {...register('selectedTypecontrat')} className="select-field w-select inputFixedMaxHeight">
            {codeListForm.clContr.map((item) =>
                        <option key={item.keyId + item.keyValNum} value={item.keyValNum}>{getCodeListKey(item.keyId, item.keyValNum)}</option> 
            )}
            </select>

          </div>
          <div className="inputFieldGroup">
          <div id="group-field-assurance-group" className="group-field">            
            <div className="group-label">
              <label aria-hidden="true" htmlFor="assurance" className="field-label">{getKeyFromKeyId("ASSUR_GROUPE")}</label>
              <MUITooltipCustom tooltipText={getKeyFromKeyId("TOOLTIP_HELP_GROUP_INSURANCE")} buttonAltText={getKeyFromKeyId("TOOLTIP_HELP_ALT_INSURANCE")} placement="top"/>
            </div>
            <div className="text-field-icon">
              <input type="number" className={GetInputFieldCssClass(errors?.GroupInsurance?true:false)} maxLength={256} {...register('GroupInsurance')} placeholder="0 €" id="assurance" />
            </div>
            {errors?.GroupInsurance && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.GroupInsurance.message as any)}</p>}
          </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default Step2Simple;